import styled from 'styled-components';

const Background = styled.div`
  background-color: ${props => (props.color ? props.color : props.theme.colors.background)};
  height: ${props => (props.height ? props.height : '100%')};
`;

export default Background;
